import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { CredusButton, CredusText } from 'ui';

import { SuccessIcon } from '../../../../../assets/images/svgs';

interface TestUploadSuccessProps {
  showSuccess: boolean;
  setShowSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setPublishTest: React.Dispatch<React.SetStateAction<boolean>>;
}

const TestUploadSuccess = ({
  showSuccess,
  setShowSuccess,
  setPublishTest,
}: TestUploadSuccessProps) => {
  const handleCancel = () => {
    setShowSuccess(false);
    setPublishTest(false);
  };
  const handleClick = () => {
    setPublishTest(false);
    setShowSuccess(false);
  };

  return (
    <Modal title="" open={showSuccess} footer="" onCancel={handleCancel}>
      <Container>
        <SuccessIcon />
        <CredusText size="xl" weight="medium">
          Success!
        </CredusText>
        <CredusText size="md" weight="regular">
          Your test has been created and saved successfully
        </CredusText>
        <CredusButton variant="secondary" onClick={handleClick}>
          Go to Manage Test
        </CredusButton>
      </Container>
    </Modal>
  );
};

export default TestUploadSuccess;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 4rem 2rem;
`;
